import { FastshiftTeamCard } from "../../cards/fastshift-team-card";
import { MigrationResourcesCard } from "../../cards/migration-resources-card";
import { SupportEngineersCard } from "../../cards/support-engineers-card";
import { RawRelationships } from "../../types";
import { mapRelationships, filterEngineers } from "../../utils";
import { BaseRelationshipsSection } from "../base-relationships-section";

export const CustomerRelationshipsSection = ({
    relationships
}: {
    relationships: RawRelationships;
}) => {
    const relationshipMapping = mapRelationships(relationships);
    const engineers = filterEngineers(relationships);

    return (
        <BaseRelationshipsSection>
            <FastshiftTeamCard
                isCustomer={true}
                relationships={relationshipMapping}
            />
            <SupportEngineersCard engineers={engineers} />
            <MigrationResourcesCard />
        </BaseRelationshipsSection>
    );
};
